export default __webpack_public_path__ + "images/90d7fd8d-rejected.svg";